<template>
    <div class="com-advantage">
        <div class="com-advantage-wrapper container">	
            <div class="com-title">五大系统优势<label>Five system advantages</label></div>
            <ul class="com-advantage__items block">
                <li class="com-advantage__item">
                    <img src="@/assets/5-1.png">
                    <b>免费使用</b>免费提供有寄系统，您只需做好线下服务
                </li>	
                <li class="com-advantage__item">
                    <img src="@/assets/5-2.png">
                    <b>有寄线路</b>有寄提供优质价廉的线路服务，覆盖英国常用线路
                </li>	
                <li class="com-advantage__item">
                    <img src="@/assets/5-3.png">
                    <b>商家线路</b>有寄免费为您对接自有线路，您的独立优势依然保留
                </li>	
                <li class="com-advantage__item">
                    <img src="@/assets/5-4.png">
                    <b>批量下单</b>单次1000条数据导入，日处理10W量级高效稳定系统
                </li>	
                <li class="com-advantage__item">
                    <img src="@/assets/5-5.png">
                    <b>财务管理</b>总览全局的财务罗盘，每天进账支出一目了然
                </li>	
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'site-advantage'
}
</script>

<style lang="less" scoped>
    .com-advantage {
        text-align: center;
        color: #8193b5;
        background-color: #f4f9ff;
        overflow: hidden;
        &__item {
            width: 20%;
            float: left;
            text-align: center;
            padding: 0 .4rem;
            line-height: 1.5;
            color: #6c81a9;
            box-sizing: border-box;
            img {
                width: 45%;
            }
            b {
                display: block;
                margin: .2rem 0;
                font-size: .28rem;
            }
        }
    }

    @media only screen and (max-width: 750px) {
        .com-advantage {
            &-wrapper {
                padding: 0 .3rem;
                box-sizing: border-box;
            }
            &__item {
                width: 100%;
                text-align: left;
                background: #fff;
                padding: .3rem;
                margin-bottom: .25rem;
                border-radius: .15rem;
                box-shadow: 0 0 0.2rem #e1e6f5;
                img {
                    float: left;
                    width: 15%;
                    margin-right: .4rem;
                }
                b {
                    margin: .15rem 0;
                    font-size: .42rem;
                    font-weight: normal;
                }
            }
        }
    }
</style>


